// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  text: 'This site uses cookies',
  link: {
    text: 'Read our privacy terms',
    label: 'Click here to read our privacy terms',
  },
  btn: {
    text: 'I agree',
    label: 'I agree to the privacy policy and authorize the use of cookies.',
  },
} as ILanguage;
